module.exports = __webpack_public_path__ + "img/image-women-videochatting.deca7f79.jpg";